import { inject } from '@angular/core';
import { ActivatedRouteSnapshot,
  CanActivateFn,
  GuardResult,
  MaybeAsync,
  Router,
  RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';


export const notAuthenticatedGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> => {

  const router = inject(Router);
  const authenticationService = inject(AuthenticationService);

  const isAnonymous = !authenticationService.isUserConnected();

  if (!isAnonymous) {
    return router.navigate(['private']);
  }

  return isAnonymous;
};


